/**
 * Natural file-name ordering for Bulk Creation uploads (01, 2, 10, a, B).
 *
 * Names are NFC-normalised first: macOS hands out decomposed (NFD) umlauts in
 * file names, which would otherwise sort apart from the same name typed on
 * another system.
 */

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

/** Compare two file names in natural order. */
export function compareNatural(a: string, b: string): number {
  return collator.compare(a.normalize('NFC'), b.normalize('NFC'));
}

/**
 * Sort items by name in natural order without mutating the input. The sort
 * is stable, so names equal under the collator keep their input order.
 */
export function naturalSort<T>(
  items: readonly T[],
  getName: (item: T) => string
): T[];
export function naturalSort(items: readonly string[]): string[];
export function naturalSort<T>(
  items: readonly T[],
  getName?: (item: T) => string
): T[] {
  const nameOf = getName ?? ((item: T) => String(item));
  return [...items].sort((a, b) => compareNatural(nameOf(a), nameOf(b)));
}
